<template>
    <div class="main_canvas">
        <v-stage ref="stage" :config="configKonva" @click="touchCanvas" @tap="touchCanvas">
<!--            <v-stage ref="stage" :config="configKonva" @click="displayPosition" @tap="touchCanvas">-->

            <v-layer :scale="{x: input_scale, y: input_scale}">
                <EditImages @activateCurtain="touchCurtain"/>
                <ClippingImage :visible="edit_mode === CONST.EDIT_MODE_DEFAULT" :offset="{x: left_margin, y: top_margin}"/>
                <BaseImage :img="base_img" :scale="ratio" :left_margin="left_margin" :top_margin="top_margin"/>
            </v-layer>

            <!--アクティブの枠線-->
            <v-layer :config="{visible: rect_visible}" @click="touchCurtain" @tap="touchCurtain">
                <EditRect
                        @move_start="moveStart"
                        @move="resetTimer"
                        @move_end="moveEnd"
                        @redraw="draw"
                />
            </v-layer>

            <!--サンプル用のデフォルト枠線-->
            <v-layer>
                <v-group
                        v-for="item in default_list"
                        @click="touchDefaultCurtain(item.id)"
                        @tap="touchDefaultCurtain(item.id)"
                        :key="item.id"
                        :opacity="edit_mode === CONST.EDIT_MODE_CLIPPING ? 0 : 1"
                >
                    <EditRectDefault
                            :default_item="item"
                            @move_start="moveStartDefault(item.id)"
                            @move="resetTimer"
                            @move_end="moveEndDefault"
                            @redraw="draw"
                    ></EditRectDefault>
                </v-group>
            </v-layer>
        </v-stage>
    </div>
</template>

<script>
    import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
    import EditRect from './EditRect'
    import BaseImage from './BaseImage'
    import EditImages from './EditImages'
    import ClippingImage from './ClippingImage'
    import CONST from '../../../assets/js/const'
    import EditRectDefault from './EditRectDefault'
    const {EDIT_CIRCLE_RADIUS, EDIT_RECT_SIZE} = CONST;

    export default {
        name: "MainCanvas",
        components: { EditRect, EditRectDefault, BaseImage, ClippingImage, EditImages },
        data() {
            return {
                CONST,
                default_size: 1000,
                canvas_size: {width: 1000, height: 1000},
                ratio: 1,
                timer_id: 0,
                base_img: null,
                left_margin: 0,
                top_margin: 0,
                past_scale: 1,
                x_offset_sum: 0,
                y_offset_sum: 0,
                x_offset_record: [],
                y_offset_record: [],
                is_on_curtain: false,
            }
        },
        computed: {
            ...mapState(['background_img', "current_image", "rect_width", "rect_height", "is_curtain", "is_check_pattern", 'edit_mode', "input_scale", "edit_rect_is_visible", "user_controlling"]),
            ...mapState('simulator', ["editing_id", "is_operating"]),
            ...mapGetters('simulator', ["editing_item", "sorted_image_list"]),
            default_list: _this => [..._this.sorted_image_list].reverse().filter(item => !!item.image_config && !item.item_data.name),
            configKonva: _this => ({
                ..._this.canvas_size,
                draggable: _this.input_scale !== 1
            }),
            rect_visible: _this => {
                return (
                    _this.edit_rect_is_visible //store内の表示設定がon
                    && _this.edit_mode === CONST.EDIT_MODE_DEFAULT //着せ替えモードで動作している
                    && !!_this.editing_item //現在編集中のアイテムが存在する
                    && _this.user_controlling //最後のユーザー操作から規定秒数以内
                    && _this.editing_item.item_data !== undefined && _this.editing_item.item_data.name !== '' //サンプル用のデフォルト枠線ではない（テクスチャ設定済み）
                )
            },
        },

        mounted() {
            this.$emit('change_bg_img',
                {
                    ratio: this.ratio,
                    marginTop: `${this.top_margin}px`,
                    marginLeft: `${this.left_margin}px`
                }
            );
            this.setStage( this.$refs.stage.getStage() );
        },
        watch: {
            background_img(img){
                this.initImage(img);
                this.$emit('change_bg_img',
                    {
                        ratio: this.ratio,
                        marginTop: `${this.top_margin}px`,
                        marginLeft: `${this.left_margin}px`
                    }
                );
            },
            input_scale(scale) {
                const stage = this.$refs.stage.getNode();
                //全画面表示に戻す
                if (scale === 1) {
                    stage.x(0);
                    stage.y(0);
                    this.past_scale = 1;
                    this.x_offset_sum = 0;
                    this.y_offset_sum = 0;
                    this.x_offset_record = [];
                    this.y_offset_record = [];
                } else {
                    //拡大縮小
                    const plus_checked = scale > this.past_scale;
                    const minus_checked = scale < this.past_scale;
                    if((plus_checked && scale > 1) || (minus_checked && scale < 1)) {
                        const calc_sign = scale > this.past_scale ? -1 : 1;
                        const magic_number = 0.065;
                        const x_offset = calc_sign * CONST.CANVAS_WIDTH * magic_number * scale;
                        const y_offset = calc_sign * CONST.CANVAS_HEIGHT * magic_number * scale;
                        this.x_offset_sum += x_offset;
                        this.y_offset_sum += y_offset;

                        //履歴を記録
                        this.x_offset_record.push(x_offset);
                        this.y_offset_record.push(y_offset);
                    } else {
                        //一段回戻すときは履歴から戻す
                        this.x_offset_sum -= this.x_offset_record.pop();
                        this.y_offset_sum -= this.y_offset_record.pop();
                    }
                    //中央に向かって拡大縮小を実行
                    stage.x(this.x_offset_sum);
                    stage.y(this.y_offset_sum);
                    this.past_scale = scale;
                }
            },
            rect_visible(visiblity) {
                this.setRectSelected(visiblity)
            },
        },

        methods: {
            ...mapMutations(["setStage" ,"setUserControlling"]),
            ...mapMutations('simulator', ["setIsOperating", "setEditId", "setRectSelected"]),
            ...mapMutations(["setUserControlling"]),
            ...mapActions(["resetTimer"]),
            ...mapActions('simulator', ["updateItemInfo"]),

            touchCanvasOld(event) {
                if(typeof event === 'undefined') return;
                if(!this.editing_item) return;

                //ズームしても値が変わらないからバグる
                console.log('カーテン左上x',this.editing_item.points.top_left.x);

                let inclusion = this.isInclude([
                    [this.editing_item.points.top_left.x,this.editing_item.points.top_left.y],
                    [this.editing_item.points.top_right.x,this.editing_item.points.top_right.y],
                    [this.editing_item.points.bottom_right.x,this.editing_item.points.bottom_right.y],
                    [this.editing_item.points.bottom_left.x,this.editing_item.points.bottom_left.y],
                ],event.evt.offsetX,event.evt.offsetY);

                if(inclusion){
                    //枠線内を選択
                    this.setUserControlling(true);
                }else{
                    //枠線外を選択（枠を非表示）
                    this.setUserControlling(false);
                }
            },
            isInclude(polygon, x, y){
                let thetaSum = 0;
                const n = polygon.length;

                // i-1 => 指定された点 =>  i の成す角度の和をthetaSumに足し込んでいく
                for (let i = 1; i < n; i++) {
                    if (polygon[i][0] === x && polygon[i][1] === y) {
                        // 指定された点が多角形の角の場合うまく角度が計算できないので、判明した時点でtrueを返す
                        return true;
                    }
                    const v1x = polygon[i - 1][0] - x;
                    const v1y = polygon[i - 1][1] - y;
                    const v2x = polygon[i][0] - x;
                    const v2y = polygon[i][1] - y;
                    thetaSum += this.computeDegree(v1x, v1y, v2x, v2y);
                }
                // 0とN番目の成す角度
                if (polygon[0][0] === x && polygon[0][1] === y) {
                    return true;
                }
                const v1x = polygon[n - 1][0] - x;
                const v1y = polygon[n - 1][1] - y;
                const v2x = polygon[0][0] - x;
                const v2y = polygon[0][1] - y;
                thetaSum += this.computeDegree(v1x, v1y, v2x, v2y);
                thetaSum = Math.abs(thetaSum);

                if (thetaSum >= 0.1) {
                    return true;
                }
                return false;
            },
            computeDegree(x1, y1, x2, y2){
                const abs1 = Math.sqrt(x1*x1+y1*y1);
                const abs2 = Math.sqrt(x2*x2+y2*y2);
                let theta = Math.acos((x1*x2+y1*y2)/(abs1*abs2)); // 内積を使って角度を計算
                let sign = Math.sign(x1*y2-y1*x2); // 外積を使って符号を計算
                theta *= sign;
                return theta
            },
            canvasResize(w,h) {
                this.canvas_size = {width: w, height: h};
                this.$el.style.width = w + 'px';
                this.$el.style.height = h + 'px';
            },
            async initImage(img) {
                this.base_img = img;

                //背景画像の長辺を全体表示させる
                const canvas_ratio = CONST.CANVAS_HEIGHT / CONST.CANVAS_WIDTH;
                const img_ratio = img.height / img.width;
                const is_horizontal_limit = canvas_ratio > img_ratio;
                this.ratio = is_horizontal_limit ? CONST.CANVAS_WIDTH / img.width : CONST.CANVAS_HEIGHT / img.height;

                //中央寄せ
                if(is_horizontal_limit) {
                    this.top_margin = (CONST.CANVAS_HEIGHT - img.height * this.ratio) / 2;
                    this.left_margin = 0;
                } else {
                    this.top_margin = 0;
                    this.left_margin = (CONST.CANVAS_WIDTH - img.width * this.ratio) / 2;
                }

                //キャンバスサイズは固定
                this.canvasResize(CONST.CANVAS_WIDTH, CONST.CANVAS_HEIGHT);

                // this.ratio = this.default_size / img.width;
                // this.canvasResize(this.default_size, img.height * this.ratio);
            },
            moveStart() {
                this.setIsOperating(true);
                this.resetTimer();
            },
            moveStartDefault(id) {
                this.touchDefaultCurtain(id);

                this.setIsOperating(true);
                this.resetTimer();
            },
            async moveEnd(points) {

                await this.updateItem(points);
                this.setIsOperating(false)
            },
            async moveEndDefault(obj) {
                await this.updateItemDefault(obj);
                this.setIsOperating(false)
            },
            async updateItem(points) {

                const data = {
                    id: this.editing_id,
                    points,
                    rect_width: this.rect_width,
                    rect_height: this.rect_height,
                };
                await this.updateItemInfo(data);
            },
            async updateItemDefault(obj) {
                const points = obj.points;
                const id = obj.item.id;

                const data = {
                    id,
                    points,
                    rect_width: this.rect_width,
                    rect_height: this.rect_height,
                };
                await this.updateItemInfo(data);
            },
            async draw() {
                this.$refs.stage.getNode().draw();
            },
            touchCurtain() {
                this.is_on_curtain = true;

                //枠線内を選択（枠を表示）
                this.setUserControlling(true);
            },
            touchCanvas() {
                if(this.is_on_curtain) {
                    this.is_on_curtain = false;
                    return;
                }
                //枠線外を選択（枠を非表示）
                this.setUserControlling(false);
            },
            touchDefaultCurtain(id) {
                this.setEditId(id);
            },
            displayPosition(evt) {
                //座標調べる用
                console.log('X座標', evt.evt.offsetX);
                console.log('Y座標', evt.evt.offsetY);
            },
         }
    }
</script>

<style scoped>

</style>
